import React from 'react'
import formalize from '~/components/utility/modal/formalize'

const DescriptionMismatchModalForm = ({}) => (<div />)

export default formalize(DescriptionMismatchModalForm)
